<template>
  <v-container class="pt-0" fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="#ed2224" title="Sales Tracking" offset="0">
          <v-layout row wrap>
            <v-flex xs4 class="py-0 px-2">
              <v-text-field
                v-model="search"
                v-on:input="onQuickFilterChanged"
                label="Search"
                single-line
                hide-details
                prepend-icon="mdi-magnify"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="py-0 px-2">
              <v-select
                v-model="agGridRawFilter.yearFilter"
                label="Year Filter"
                @change="updateFilter"
                :items="['All', '2020', '2019', '2018']"
              ></v-select>
            </v-flex>
            <v-flex xs4 class="py-0 px-2">
              <v-select
                v-model="agGridRawFilter.statusFilter"
                label="Status Filter"
                @change="updateFilter"
                :items="['All', 'Enquiry', 'Reply Sent', 'Introduction']"
              ></v-select>
            </v-flex>
          </v-layout>

          <div slot="header-actions">
            <v-btn small raised color="info" @click="addClicked()">{{
              formOpen ? "Close" : "Add"
            }}</v-btn>
          </div>

          <ag-grid-vue
            :style="{ width, height }"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :rowData="rowData"
            :animateRows="true"
            :rowBuffer="5"
            :pagination="true"
            :isExternalFilterPresent="isExternalFilterPresent"
            :doesExternalFilterPass="doesExternalFilterPass"
            rowSelection="multiple"
            @grid-ready="onGridReady"
            @cellDoubleClicked="onCellDoubleClick"
          ></ag-grid-vue>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="replyEmailDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Reply</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="replyFormDialog">
              <v-layout wrap>
                <v-flex xs12>
                  <v-textarea
                    v-model="replyFormData.reply"
                    label="Reply"
                  ></v-textarea>
                </v-flex>
                <v-flex v-if="businesses" xs12>
                  <v-checkbox
                    v-model="replyFormData.copySelf"
                    :label="`Copy Self (${currentBusinessEmail()})`"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            flat
            @click="
              replyEmailDialog = false;
              replyFormData = {};
            "
            >Close</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="emailLoading"
            flat
            @click="sendReply()"
            >Send Reply</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="formOpen" class="mt-2">
      <v-card>
        <v-toolbar color="red" dense dark class="mb-0">
          Sales Enquiry
          <v-spacer></v-spacer>

          <v-btn
            v-if="formOpen"
            :loading="deleting"
            small
            raised
            color="error"
            class="mr-2"
            @click="deleteItem()"
          >
            Delete
          </v-btn>
          <v-btn small raised color="success" :loading="saving" @click="save()">
            Save & Close
          </v-btn>
        </v-toolbar>
        <v-card flat>
          <v-card-text>
            <v-form ref="impactBusinessForm">
              <v-layout class="salesForm" key="form" wrap justify-center>
                <!-- Customer Details Section -->
                <v-flex class="mb-4" xs12 md6>
                  <v-card class="ma-2" elevation="5" style="height: 100%">
                    <v-toolbar color="grey darken-2" dense dark class="mb-0">
                      Customer Details
                      <v-spacer></v-spacer>
                      <span class="textLabel">Time of Enquiry:&nbsp;</span>
                      {{ formData.dateOfEnquiry | moment }}
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Customer Name"
                            v-model="formData.fullName"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-select
                            label="Entity Name"
                            v-model="formData.impactBusiness_id"
                            :items="impactBusinesses"
                            item-text="company"
                            item-value="id"
                            clearable
                            hide-details
                          >
                          </v-select>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Customer Email"
                            v-model="formData.email"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Customer Number"
                            v-model="formData.mobile"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Customer Address"
                            v-model="formData.address"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            dense
                            label="Join Email list"
                            v-model="formData.permission"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Enquiry Details Section -->
                <v-flex class="mb-4" xs12 md6>
                  <v-card class="ma-2" elevation="5" style="height: 100%">
                    <v-toolbar color="grey darken-2" dense dark class="mb-0">
                      Enquiry Details
                      <v-tooltip v-if="formData.status == 'Unopened'" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon class="ml-2" color="white" dark v-on="on">
                            mdi-email
                          </v-icon>
                        </template>
                        <span>Email Unopened</span>
                      </v-tooltip>
                      <v-tooltip v-if="formData.status == 'Opened'" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon class="ml-2" color="green" dark v-on="on">
                            mdi-email
                          </v-icon>
                        </template>
                        <span>Email Opened</span>
                      </v-tooltip>
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 class="px-1 mb-1">
                          <v-select
                            label="Sale Enquiry Status"
                            v-model="formData.upstreamStatus"
                            hide-details
                            :items="[
                              'Enquiry',
                              'Comms Confirmed',
                              'Sale Pending',
                              'Sale Confirmed',
                              'Sale Completed',
                              'Sale Fallen Through',
                              'Introduction',
                            ]"
                          >
                          </v-select>
                        </v-flex>
                        <br />
                        <v-flex xs12 sm8 class="px-1 mb-1">
                          <v-autocomplete
                            v-model="formData.business_id"
                            :items="businesses"
                            item-text="name"
                            item-value="id"
                            label="Supplier who received the enquiry"
                            clearable
                            hide-details
                          />
                        </v-flex>
                        <v-flex xs12 sm4 class="px-1 mb-1">
                          <v-autocomplete
                            label="Enquiry Via"
                            v-model="formData.via"
                            :items="viaOptions"
                            item-value="title"
                            hide-details
                          >
                            <template slot="selection" slot-scope="data">
                              <!-- HTML that describe how select should render selected items -->
                              <span class="font-weight-bold">
                                {{ data.item.title }}
                              </span>
                              &nbsp;
                              {{ data.item.description }}
                            </template>
                            <template slot="item" slot-scope="data">
                              <!-- HTML that describe how select should render items when the select is open -->
                              <span class="font-weight-bold">
                                {{ data.item.title }}
                              </span>
                              &nbsp;
                              {{ data.item.description }}
                            </template>
                          </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 class="px-1 mb-1">
                          <v-autocomplete
                            v-model="formData.goodCause"
                            :items="goodCauses"
                            item-text="name"
                            item-value="name"
                            label="Area of Impact they want to Support"
                            clearable
                            hide-details
                          />
                        </v-flex>
                        <v-flex xs12 class="px-1 mb-1">
                          <v-textarea
                            label="Message from Customer"
                            v-model="formData.message"
                            hide-details
                          ></v-textarea>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Enquiry About"
                            v-model="formData.enquiryAbout"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Promo Code Used"
                            v-model="formData.promoCode"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Outcome of Sale Section -->
                <v-flex class="mb-4" xs12 md6>
                  <v-card class="ma-2" elevation="5" style="height: 100%">
                    <v-toolbar color="grey darken-2" dense dark class="mb-0">
                      Outcome of Sale
                    </v-toolbar>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md4 class="px-1 mb-1">
                          <v-text-field
                            label="Invoice #"
                            v-model="formData.xeroInv"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4 class="px-1 mb-1">
                          <v-text-field
                            label="Total Revenue of Sale"
                            v-model="formData.revenue"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md4 class="px-1 mb-1">
                          <v-text-field
                            label="UpstreamNZ Contribution"
                            v-model="formData.upstreamContribution"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 class="px-1 mb-1">
                          <v-checkbox
                            label="Paid To GC"
                            v-model="formData.paidToGC"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs12 class="px-1 mb-1">
                          <v-textarea
                            label="Admin notes"
                            v-model="formData.adminNotes"
                            hide-details
                          ></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <!-- Other Data -->
                <v-flex class="mb-4" xs12 md6>
                  <v-card class="ma-2" elevation="5" style="height: 100%">
                    <v-toolbar color="grey darken-2" dense dark class="mb-0">
                      Other Data
                      <v-spacer></v-spacer>

                      <span class="textLabel">Type of Sale:&nbsp;</span>
                      {{ formData.impactBusiness_id ? "Entity" : "Consumer" }}
                    </v-toolbar>

                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Category of Supplier"
                            v-model="formData.businessCategories"
                            readonly
                            hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="px-1 mb-1">
                          <v-text-field
                            label="Sub-Category of Supplier"
                            v-model="formData.businessSubCategories"
                            readonly
                            hide-details
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 class="px-1 mb-1">
                          <v-text-field
                            label="How did you hear about us?"
                            v-model="formData.reference"
                            hide-details
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import paidToGC from "@/components/agGrid/paidToGC";
  import enquiryStatus from "@/components/agGrid/enquiryStatus";
  import { AgGridVue } from "ag-grid-vue";

  export default {
    components: {
      paidToGC,
      AgGridVue,
      enquiryStatus,
    },
    data: () => ({
      //AG-Grid
      columnDefs: null,
      rowData: null,
      columnApi: null,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        autoHeight: true,
      },
      width: "100%",
      height: "calc(100vh - 250px)",
      search: "",
      searchDebounce: null,
      agGridFilter: {
        yearFilter: "All",
        statusFilter: "All",
      },
      agGridRawFilter: {
        yearFilter: "All",
        statusFilter: "All",
      },
      activeTab: null,
      saving: false,
      deleting: false,
      formOpen: false,
      formData: {},
      replyEmailDialog: false,
      replyFormData: {},
      emailLoading: false,
      viaOptions: [
        {
          title: "Email off Website",
          description: "(Enquiry)",
        },
        {
          title: "Call Tracking",
          description: "(Enquiry)",
        },
        {
          title: "Repeat",
          description: "(Sale Inputted)",
        },
        {
          title: "Affiliate",
          description: "(Enquiry)",
        },
        {
          title: "Connection",
          description: "(Supplier Email)",
        },
        {
          title: "Other",
          description: "",
        },
      ],
    }),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
        goodCauses: "goodCauses/approved",
        salesEnquiries: "business/salesEnquiries",
        businesses: "business/list",
        impactBusinesses: "impactBusinesses/list",
        aGGridActionMenu: "agGrid/aGGridActionMenu",
        selectedRowData: "agGrid/selectedRowData",
      }),
      goodCauseName: function () {
        let names = [];
        this.goodCauses.forEach((goodCause) => {
          names.push(goodCause.name);
        });
        return names;
      },
    },
    watch: {
      salesEnquiries: function (oldSE, newSE) {
        this.setGridData(this.salesEnquiries);
      },
      aGGridActionMenu: function () {
        if (this.aGGridActionMenu == true) {
          this.viewStockDetails();
          this.updateAGGridActionMenu();
        }
      },
      $route: function (to, from) {
        if (this.$route.params.hasOwnProperty("id")) {
          this.formData = this.salesEnquiries.find(
            (enquiry) => enquiry.id == this.$route.params.id
          );
          if (typeof this.formData != "undefined") {
            this.formData.paidToGC = parseInt(this.formData.paidToGC);
            this.image = null;
            this.saving = false;
            this.formOpen = true;
            this.checkIfAlreadyOpened();
          }
        } else {
          this.formOpen = false;
          this.saving = false;
        }
      },
    },
    mounted() {
      this.columnDefs = [
        {
          headerName: "Enq ID #",
          field: "id",
          comparator: numberComparator,
        },
        {
          headerName: "Date of Enquiry",
          field: "dateOfEnquiry",
          suppressSizeToFit: true,
          valueFormatter: dateFormatter,
          width: "160",
        },
        {
          headerName: "Year",
          field: "dateOfEnquiry",
          suppressSizeToFit: true,
          valueFormatter: yearFormatter,
          width: "80",
        },

        {
          headerName: "Customer Name",
          field: "fullName",
        },
        {
          headerName: "Entity Name",
          field: "impactBusinessName",
        },
        {
          headerName: "Enquiry for (Supplier)",
          field: "businessName",
        },
        {
          headerName: "Enquiry About?",
          field: "impactBusinessName",
        },
        {
          headerName: "Area of Impact",
          field: "goodCause",
        },
        {
          headerName: "Enquiry Status",
          suppressSizeToFit: true,
          width: "200",
          cellRendererFramework: "enquiryStatus",
          field: "upstreamStatus",
        },
        {
          headerName: "GC pd",
          field: "paidToGC",
          suppressSizeToFit: true,
          cellRendererFramework: "paidToGC",
          width: "90",
        },
        {
          headerName: "Enquiry Via",
          suppressSizeToFit: true,
          width: "130",
          field: "via",
        },
        {
          headerName: "Open Status",
          suppressSizeToFit: true,
          width: "130",
          field: "status",
        },
        {
          headerName: "INV #",
          suppressSizeToFit: true,
          width: "130",
          field: "xeroInv",
        },
        {
          headerName: "Total Revenue of Sale (incl gst)",
          field: "revenue",
        },
        {
          headerName: "UNZ Contributions (incl gst)",
          field: "upstreamContribution",
        },
        {
          headerName: "UNZ Admin Notes",
          field: "adminNotes",
        },
        {
          headerName: "Customer Email",
          field: "email",
        },
        {
          headerName: "Customer Numer",
          field: "mobile",
        },
        {
          headerName: "Customer Address",
          field: "address",
        },
        {
          headerName: "Category of Supplier",
          field: "businessCategories",
        },
        {
          headerName: "Sub-Category of Supplier",
          field: "businessSubCategories",
        },
        {
          headerName: "Join Email Y/N",
          field: "permission",
        },
        {
          headerName: "Promo Code",
          field: "promoCode",
        },
      ];
      this.$store.dispatch("business/loadSalesEnquiries").then(() => {
        this.setGridData(this.salesEnquiries);
        if (this.$route.params.hasOwnProperty("id")) {
          if (this.formData.id != this.$route.params.id) {
            this.formData = this.salesEnquiries.find(
              (enquiry) => enquiry.id == this.$route.params.id
            );
          }
          if (typeof this.formData != "undefined") {
            this.image = null;
            this.saving = false;
            this.formOpen = true;
            this.checkIfAlreadyOpened();
          }
        }
      });
      this.$store.dispatch("business/loadAllAdmin");
      this.$store.dispatch("goodCauses/loadAll");
    },
    methods: {
      updateFilter() {
        this.agGridFilter = this.agGridRawFilter;
        this.gridApi.onFilterChanged();
      },
      isExternalFilterPresent() {
        return (
          this.agGridFilter.yearFilter !== "All" ||
          this.agGridFilter.statusFilter !== "All"
        );
      },
      doesExternalFilterPass(node) {
        let passed = 0;

        //Year Filter
        if (
          this.agGridFilter.yearFilter == "All" ||
          moment.utc(node.data.dateOfEnquiry).local().format("YYYY") ==
            this.agGridFilter.yearFilter
        ) {
          passed += 1;
        }

        // Status Filter
        if (
          this.agGridFilter.statusFilter == "All" ||
          node.data.upstreamStatus == this.agGridFilter.statusFilter
        ) {
          passed += 1;
        }

        if (passed == 2) {
          return true;
        } else {
          return false;
        }
      },

      setGridData(data) {
        const rowData = data;

        this.gridApi.setRowData(rowData);
        setTimeout(() => {
          var allColumnIds = [];
          this.columnApi.getAllColumns().forEach(function (column) {
            if (column.colDef.suppressSizeToFit != true) {
              allColumnIds.push(column.colId);
            }
          });

          // this.gridApi.sizeColumnsToFit();
          this.columnApi.autoSizeColumns(allColumnIds, false);
        }, 50);
      },
      onQuickFilterChanged() {
        clearTimeout(this.searchDebounce);

        this.searchDebounce = setTimeout(() => {
          this.gridApi.setQuickFilter(this.search);
        }, 150);
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        if (this.salesEnquiries.length != 0) {
          this.setGridData();
        }
      },
      onCellDoubleClick(cell) {
        this.$store.dispatch("agGrid/setSelectedRowData", cell.data);
        this.viewStockDetails();
      },
      updateAGGridActionMenu() {
        this.$store.dispatch("agGrid/setAGGridActionMenuState", {});
      },
      viewStockDetails() {
        this.open(this.selectedRowData);
      },
      busName(id) {
        let business = this.businesses.find((b) => b.id == id);
        if (typeof business != "undefined") {
          return business.name;
        } else {
          return "";
        }
      },
      formatDate(date) {
        return date.slice(0, 11);
      },
      toggleForm() {
        if (!this.formOpen) {
          this.formData = {};
        }
        // this.formOpen = !this.formOpen;
        this.$router.push("/admin/salesEnquiry");
        setTimeout(() => {
          this.setGridData(this.salesEnquiries);
        }, 200);
      },
      addClicked() {
        if (!this.formOpen) {
          this.formData = {};
        }
        this.formOpen = !this.formOpen;
      },
      open(business) {
        this.$router.push(`/admin/salesEnquiry/${business.id}`);
        if (!this.formOpen) {
          this.image = null;
          this.saving = false;
          this.formData = business;
          this.formOpen = true;
          this.checkIfAlreadyOpened();
        }
      },
      checkIfAlreadyOpened() {
        if (
          (this.formData.status == "Unopened" ||
            this.formData.status == "Opened") &&
          this.userData.business_id == this.formData.business_id
        ) {
          this.formData.status = "Viewed";
          let today = new Date();
          this.formData.enquiryOpened = `${today.getFullYear()}-${
            today.getMonth() + 1
          }-${today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getMinutes()}`;
          this.$store.dispatch("business/salesEnquirySave", this.formData);
        }
      },
      sendReply() {
        this.emailLoading = true;
        try {
          let business = this.businesses.find(
            (b) => b.id == this.formData.business_id
          );
          let payload = {
            id: this.formData.id,
            business_id: this.formData.business_id,
            reply: this.replyFormData.reply,
            copySelf: this.replyFormData.copySelf,
            customerEmail: this.formData.email,
            customerName: this.formData.fullName,
            businessEmail: business.email,
            businessName: business.name,
          };
          this.$store
            .dispatch("emailSending/salesEnquirySendReply", payload)
            .then((result) => {
              this.emailLoading = false;
              this.replyEmailDialog = false;
              this.formData.status = "Reply Sent";
              this.$store.dispatch("business/loadSalesEnquiries");
              if (result.Result == "Success") {
                this.$swal({
                  title: "Success!",
                  text: `Your email has been sent.`,
                  type: "success",
                  confirmButtonText: "Ok",
                });
              } else {
                this.$swal({
                  title: "Error!",
                  text: `An Error has occured, Please try again later.`,
                  type: "success",
                  confirmButtonText: "Ok",
                });
              }
            });
        } catch (error) {
          this.emailLoading = false;
          this.$swal({
            title: "Error!",
            text: `An Error has occured, Please try again later.`,
            type: "error",
            confirmButtonText: "Ok",
          });
        }
      },
      currentBusinessEmail() {
        try {
          let business = this.businesses.find(
            (b) => b.id == this.formData.business_id
          );
          return business.email;
        } catch (error) {
          return "Unknown";
        }
      },
      save() {
        this.saving = true;
        for (const [key, value] of Object.entries(this.formData)) {
          if (value == undefined || value == null) {
            delete this.formData[key];
          }
        }
        if (this.formData.hasOwnProperty("id")) {
          this.$store
            .dispatch("business/salesEnquirySave", this.formData)
            .then(() => {
              // this.$swal("Saved", "This Sales Enquiry has been Saved", "success");
              this.toggleForm();
              this.saving = false;
            });
        } else {
          this.$store
            .dispatch("business/salesEnquiryAdd", this.formData)
            .then(() => {
              // this.$swal(
              //   "Added",
              //   "The Sales Enquiry has been created",
              //   "success"
              // );
              this.toggleForm();
              this.saving = false;
            });
        }
      },
      deleteItem() {
        this.$swal
          .fire({
            icon: "warning",
            title: "Are you sure you want to delete this sale enquiry card?",
            showDenyButton: true,
            showCancelButton: true,
            cancelButtonText: `Don't Delete`,
            confirmButtonText: `Delete`,
            confirmButtonColor: "red",
          })
          .then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              this.deleting = true;
              this.$store
                .dispatch("business/deleteSalesEnquiry", this.formData.id)
                .then(() => {
                  this.deleting = false;
                  this.toggleForm();
                  this.$swal(
                    "Deleted",
                    "The Sales Enquiry has been deleted",
                    "success"
                  );
                });
            }
          });
      },
    },
    filters: {
      moment: function (date) {
        return moment.utc(date).local().format("MMM Do YYYY, h:mm a");
      },
    },
  };
  window.dateFormatter = function dateFormatter(params) {
    if (params.data.dateOfEnquiry) {
      return moment
        .utc(params.data.dateOfEnquiry)
        .local()
        .format("MMM-DD, h:mma");
    } else {
      return "";
    }
  };
  window.yearFormatter = function yearFormatter(params) {
    if (params.data.dateOfEnquiry) {
      return moment.utc(params.data.dateOfEnquiry).local().format("YYYY");
    } else {
      return "";
    }
  };
  window.numberComparator = function numberComparator(valueA, valueB) {
    return parseInt(valueA) - parseInt(valueB);
  };
</script>

<style>
  .croppa-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .icon-remove {
    position: absolute;
    top: 5px !important;
    right: -35px !important;
  }

  .croppa-container canvas {
    border: 1px solid;
  }
</style>

<style scoped>
  .textLabel {
    font-weight: 500;
  }
</style>

